<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <!-- begin b-card -->
        <b-card no-body>
          <b-card-header
            header-tag="header"
            class="card-header pointer-cursor collapsed"
            aria-expanded="false"
            v-b-toggle.explanation
          >
            <i class="fas " :class="isVisible ? 'fa-minus' : 'fa-plus'"></i>
            {{ $t('question.addExplanation') }}
            <span>
              <i
                class="far fa-question-circle"
                v-tooltip="
                  'You can add explanation for the question here. This will be shown while reviewing the exam or in tutor mode exam.'
                "
              ></i
            ></span>
          </b-card-header>
          <b-collapse
            id="explanation"
            visible
            accordion="explanation"
            v-model="isVisible"
          >
            <b-card-body style="background-color: #f2f3f4;">
              <ckeditor
                :editor="editor"
                v-model="model.explanation"
                :config="editorConfig"
              ></ckeditor>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- end b-card -->
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { mapState } from 'vuex'
Vue.use(CKEditor)

export default {
  name: 'Explanation',
  props: ['value', 'validate'],
  data() {
    return {
      isVisible: false,
      model: {},
      editor: ClassicEditor,
      editorConfig: {
        // Editor configuration
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          'link',
          'bulletedList',
          'numberedList',
          'MediaEmbed',
          'blockQuote',
          'imageUpload',
          'insertTable',
          '|',
          'alignment',
          'mathType',
          'ChemType',
          'outdent',
          'indent',
          'undo',
          'redo'
        ]
      }
    }
  },
  created() {
    this.model = this.value
    this.setEdit()
  },
  computed: {
    ...mapState('eschool/eExam/question', ['edit_data'])
  },
  methods: {
    setEdit() {
      if (!_.isEmpty(this.edit_data) && this.edit_data !== undefined) {
        this.model.explanation = this.edit_data.explanation
      }
    }
  }
}
</script>
